import { render, staticRenderFns } from "./TownsStreetsServiceOrderProportion.vue?vue&type=template&id=72583e6e&scoped=true&"
import script from "./TownsStreetsServiceOrderProportion.vue?vue&type=script&lang=js&"
export * from "./TownsStreetsServiceOrderProportion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72583e6e",
  null
  
)

export default component.exports